import { BrowserRouter as Router } from 'react-router-dom';
import { AppProviders } from './providers';
import DrilldownModal from './components/drilldown/DrilldownModal';
import SpecializedDrilldownModals from './components/drilldown/SpecializedDrilldownModals';
import { WelcomeModal, QuickReferenceModal, GuidedTour } from './components/tour';
import { PageHelpPanel, GlossaryModal } from './components/help';
import { ErrorBoundary } from './components/common';
import FileDropGuard from './components/common/FileDropGuard';
import TermsAcceptanceModal from './components/legal/TermsAcceptanceModal';
import SupplierConfirmationModal from './components/documents/SupplierConfirmationModal';
import EnvironmentIndicator from './components/EnvironmentIndicator';
import { Toaster } from 'sonner';
import { AppRoutes } from './routes';

function App() {
  return (
    <ErrorBoundary
      onError={(error) => {
        // Log critical app-level errors
        console.error('[App] Critical error:', error);
        // TODO: Send to error tracking service (e.g., Sentry)
      }}
    >
      <Router>
        <AppProviders>
          <AppRoutes />
          <TermsAcceptanceModal />
          <SupplierConfirmationModal />
          <DrilldownModal />
          <SpecializedDrilldownModals />
          <WelcomeModal />
          <QuickReferenceModal />
          <GuidedTour />
          <PageHelpPanel />
          <GlossaryModal />
          {/* Middle of the screen: top-right sat over the bell and the profile menu, so a
              "Notification deleted" toast blocked the very button it was about (28 Sep 2026). */}
          <Toaster position="top-center" offset={{ top: '45vh' }} richColors />
          {/* Customer review 11 Sep: a file dropped outside an upload zone must not open in the tab. */}
          <FileDropGuard />
          <EnvironmentIndicator />
        </AppProviders>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
